export default "__VITE_ASSET__DSOZxbf3__"